import { FC } from "react";
import { ListItem } from "@mui/material";
import "@/components/navigation/navigationBar.css";
import {
  NavigationItemButton,
  NavigationListItemContent,
  NavigationNavLink,
} from "@/components/navigation/navigationItems";
import Restricted from "@/consumer/restricted";
import { useTranslation } from "react-i18next";

interface Props {
  drawerOpen: boolean;
  selectedIndex: number;
  handleListItemClick?: any;
  subdomain: string;
}

const CustomerRoutes: FC<Props> = ({
  drawerOpen,
  selectedIndex,
  handleListItemClick,
  subdomain,
}) => {
  const { t } = useTranslation();
  if (subdomain === "portal") {
    return (
      <>
        <Restricted permissionRequired="frontend_view_user_appointment">
          <ListItem
            disablePadding
            className={drawerOpen ? "navigationItemOpen" : "navigationItem"}
          >
            <NavigationNavLink to="appointmentrequestopen">
              <NavigationItemButton
                drawerOpen={drawerOpen}
                onClick={(event: any) => handleListItemClick(event, 50)}
                selected={selectedIndex === 50}
              >
                <NavigationListItemContent
                  drawerOpen={drawerOpen}
                  primaryText={t("open_appointments")}
                  icon="appointments"
                />
              </NavigationItemButton>
            </NavigationNavLink>
          </ListItem>
        </Restricted>
        <Restricted permissionRequired="frontend_view_appointment_archive">
          <ListItem
            disablePadding
            className={drawerOpen ? "navigationItemOpen" : "navigationItem"}
          >
            <NavigationNavLink to="appointmentArchive">
              <NavigationItemButton
                drawerOpen={drawerOpen}
                onClick={(event: any) => handleListItemClick(event, 51)}
                selected={selectedIndex === 51}
              >
                <NavigationListItemContent
                  drawerOpen={drawerOpen}
                  primaryText={t("appointment_archive")}
                  icon="bookedAppointments"
                />
              </NavigationItemButton>
            </NavigationNavLink>
          </ListItem>
        </Restricted>
        <Restricted permissionRequired="frontend_view_accidentbook">
          <ListItem
            disablePadding
            className={drawerOpen ? "navigationItemOpen" : "navigationItem"}
          >
            <NavigationNavLink to="/accidentBook">
              <NavigationItemButton
                drawerOpen={drawerOpen}
                onClick={(event: any) => handleListItemClick(event, 52)}
                selected={selectedIndex === 52}
              >
                <NavigationListItemContent
                  drawerOpen={drawerOpen}
                  primaryText={t("accidentbook")}
                  icon="accidentbook"
                />
              </NavigationItemButton>
            </NavigationNavLink>
          </ListItem>
        </Restricted>
      </>
    );
  } else return <></>;
};

export default CustomerRoutes;
